import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "onChange", "defaultValue", "min", "max"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useEventCallback, useIsomorphicLayoutEffect } from '@cian/react-utils';
import { IMaskInput } from '../../../../internal/components/IMaskInput';
import { useControlled } from '../../../../internal/hooks';
import { invoke } from '../../../../internal/utils';
import { format } from '../../../../internal/utils/date';
import { IMASK_DATE_INPUT_OPTIONS } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
export var NativeDateMaskInput = /*#__PURE__*/React.forwardRef(function NativeDateMaskInput(props, ref) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var as = props.as,
    onChange = props.onChange,
    defaultValue = props.defaultValue,
    min = props.min,
    max = props.max,
    rest = _objectWithoutProperties(props, _excluded);
  var _useControlled = useControlled({
      controlled: props.value,
      default: defaultValue !== undefined ? defaultValue : undefined
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    value = _useControlled2[0],
    setValue = _useControlled2[1];
  var fotmattedValue = toStringValue(value);
  var inputValueRef = React.useRef(fotmattedValue);
  var _React$useState = React.useState(fotmattedValue),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    inputValue = _React$useState2[0],
    _setInputValue = _React$useState2[1];
  var setInputValue = useEventCallback(function (nextValue) {
    inputValueRef.current = nextValue;
    _setInputValue(nextValue);
  });
  useIsomorphicLayoutEffect(function () {
    var nextInputValue = toStringValue(value);
    if (inputValueRef.current !== nextInputValue) {
      setInputValue(nextInputValue);
    }
  }, [value]);
  var handleInputAccept = function handleInputAccept(eventValue, inputMask) {
    setInputValue(eventValue);
    var nextValue = inputMask.typedValue;
    setValue(nextValue);
    if (toStringValue(nextValue) !== toStringValue(value)) {
      invoke(onChange, nextValue);
    }
  };
  var handleBlur = function handleBlur(e) {
    var finalInputValue = toStringValue(value);
    if (inputValue !== finalInputValue) {
      setInputValue(finalInputValue);
    }
    invoke(props.onBlur, e);
  };
  return /*#__PURE__*/_jsx(IMaskInput, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    as: as,
    type: "tel",
    value: inputValue,
    options: IMASK_DATE_INPUT_OPTIONS,
    onAccept: handleInputAccept,
    onBlur: handleBlur,
    spellCheck: false
  }));
});
var INPUT_FORMAT = 'dd.MM.yyyy';
function toStringValue(value) {
  if (value instanceof Date) {
    return format(INPUT_FORMAT, value);
  }
  return '';
}